<div class="" style="overflow:auto;height:400px;" *ngIf="data.title=='banner'">

    <div class="modal-body" style="height:330px;padding-top: 0px;padding-left: 0px;padding-right: 0px;">

        <div class="popup">
            <div class="close_button" (click)="no()">
                <i class="fa fa-times"></i>
            </div>
            <img [src]="promotionImage" alt="" [ngClass]="data.isPortrait ? 'banner_image1' : 'banner_image'">

        </div>

    </div>
</div>

<div class="row" *ngIf="data.title=='t&c'">
    <div class="col-md-12">
        <div class="row modal_header">
            <div class="col-9">
                <span class="ml-2">Promotion Content</span>
            </div>
            <div class="col-3 text-right">
                <a style="cursor:pointer">
                    <i class="fa-solid fa-xmark" (click)="no()" style="font-size: xx-large;"></i>
                </a>
            </div>
        </div>
        <div class="card card_content">
            <quill-editor [(ngModel)]="data.editorContent"   [modules]="toolbarModules" style="background-color: white;"></quill-editor>
            <div class="row mt-4">
                <div class="col-xl-12 text-center">
                    <button class="btn btn-secondary mr-3" (click)="getEditorContent()">
                        Save
                    </button>
                    <button class="btn btn-primary" (click)="no()">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>